var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-172 -252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75,4.5A.755.755,0,0,1,0,3.75v-3A.755.755,0,0,1,.75,0,.755.755,0,0,1,1.5.75v3A.755.755,0,0,1,.75,4.5Z",
    transform: "translate(179.25 253.25)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75,4.5A.755.755,0,0,1,0,3.75v-3A.755.755,0,0,1,.75,0,.755.755,0,0,1,1.5.75v3A.755.755,0,0,1,.75,4.5Z",
    transform: "translate(187.25 253.25)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.75,1.5H.75A.755.755,0,0,1,0,.75.755.755,0,0,1,.75,0h17a.755.755,0,0,1,.75.75A.755.755,0,0,1,17.75,1.5Z",
    transform: "translate(174.75 260.34)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75,20h-8C2.1,20,0,17.9,0,14.25V5.75C0,2.1,2.1,0,5.75,0h8C17.4,0,19.5,2.1,19.5,5.75v8.5C19.5,17.9,17.4,20,13.75,20Zm-8-18.5C2.89,1.5,1.5,2.89,1.5,5.75v8.5c0,2.86,1.39,4.25,4.25,4.25h8c2.86,0,4.25-1.39,4.25-4.25V5.75c0-2.86-1.39-4.25-4.25-4.25Z",
    transform: "translate(174.25 254.75)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,2a1,1,0,0,1-.38-.08,1.155,1.155,0,0,1-.33-.21,1.155,1.155,0,0,1-.21-.33A1,1,0,0,1,0,1,1.052,1.052,0,0,1,.29.29,1.155,1.155,0,0,1,.62.08.956.956,0,0,1,1.2.02a.636.636,0,0,1,.18.06.757.757,0,0,1,.18.09l.15.12a1.576,1.576,0,0,1,.12.15.757.757,0,0,1,.09.18A.636.636,0,0,1,1.98.8,1.355,1.355,0,0,1,2,1a1.052,1.052,0,0,1-.29.71A1.052,1.052,0,0,1,1,2Z",
    transform: "translate(179.5 264.5)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,2a1.052,1.052,0,0,1-.71-.29l-.12-.15a.757.757,0,0,1-.09-.18A.636.636,0,0,1,.02,1.2,1.355,1.355,0,0,1,0,1,1,1,0,0,1,.08.619,1.155,1.155,0,0,1,.29.289,1,1,0,0,1,1.38.079a1.032,1.032,0,0,1,.33.21A1.052,1.052,0,0,1,2,1a1.355,1.355,0,0,1-.02.2.636.636,0,0,1-.06.18.757.757,0,0,1-.09.18l-.12.15a1.032,1.032,0,0,1-.33.21A1,1,0,0,1,1,2Z",
    transform: "translate(183 264.501)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,2a1,1,0,0,1-.38-.08,1.155,1.155,0,0,1-.33-.21,1.032,1.032,0,0,1-.21-.33A1,1,0,0,1,0,1,1.052,1.052,0,0,1,.29.289,1.155,1.155,0,0,1,.62.079a1,1,0,0,1,1.09.21,1.576,1.576,0,0,1,.12.15.757.757,0,0,1,.09.18.6.6,0,0,1,.06.19A1.225,1.225,0,0,1,2,1a1.052,1.052,0,0,1-.29.71A1.052,1.052,0,0,1,1,2Z",
    transform: "translate(179.5 268.001)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H24V24H0Z",
    transform: "translate(172 252)",
    fill: "none",
    opacity: 0
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.043f600d5b63814ff470032dce5976d7.svg";
export { ForwardRef as ReactComponent };